import {
  FC,
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
  useEffect,
} from 'react'

interface IUIContext {
  isLoading: boolean
  setLoading: Dispatch<SetStateAction<boolean>>
  isSidebarOpen: boolean
  setSidebarOpen: Dispatch<SetStateAction<boolean>>
}

interface IUIContextProvider {
  children: ReactNode
}

const UIContext = createContext<IUIContext>({
  isLoading: false,
  setLoading: () => false,
  isSidebarOpen: true,
  setSidebarOpen: () => false,
})

const UIContextProvider = ({ children }: IUIContextProvider) => {
  const [isLoading, setLoading] = useState(false)
  const [isSidebarOpen, setSidebarOpen] = useState(false)

  useEffect(() => {
    if ('caches' in window) {
      caches.keys().then((names) => {
        // Delete all the cache files
        names.forEach((name) => {
          caches.delete(name)
        })
      })

      // Makes sure the page reloads. Changes are only visible after you refresh.
      // window.location.reload()
    }
  }, [])

  return (
    <UIContext.Provider
      value={{ isLoading, setLoading, isSidebarOpen, setSidebarOpen }}
    >
      {children}
    </UIContext.Provider>
  )
}

const useUI = () => useContext(UIContext)

export { UIContextProvider, useUI }
